import React from 'react';
import UserList from '@/components/UserList';

const UsersPage: React.FC = () => {
  return <UserList />;
};

export default UsersPage;
